import React from 'react';
import PropTypes from 'prop-types';
import {isArray, map, flatMap, uniqBy} from 'lodash';

import TagList from './tag-list';

import searchHoc from '../components-app/search-wrapper';

// Styles
import './network-tags.scss';

const servicesDataKey = 'networkList';

const NetworkTags = ({handleUpdateNetworkTags, id, searchData, values}) => (
    <TagList
        filter={true}
        filterBy="label,value"
        filterPlaceholder="Network Tag"
        handleUpdateTag={handleUpdateNetworkTags}
        id={id}
        options={
            isArray(searchData.networks)
                ? uniqBy(
                      flatMap(searchData.networks, network =>
                          map(network.tags, currentTag => ({label: currentTag, value: currentTag}))
                      ),
                      'value'
                  )
                : []
        }
        values={values}
    />
);

NetworkTags.propTypes = {
    handleUpdateNetworkTags: PropTypes.func.isRequired,
    id: PropTypes.string.isRequired,
    searchData: PropTypes.oneOfType([PropTypes.array, PropTypes.object]).isRequired,
    values: PropTypes.array,
};

export default searchHoc(NetworkTags, servicesDataKey);
